import { useEffect, useState } from "react";
import { useLocationConfigContext } from "../../context/LocationConfigContext";
import { OfficeTable } from "./components/OfficeTable";
import { ETypeOfNotification, Modal, setNotification } from "medere-ui-framework";
import { Button } from "primereact/button";
import { Office } from "../../../../interface/interface";
import { removeHospitalLocation } from "../../../../servicesHooks/Location/useLocationConfigService";
import { useDispatch } from "react-redux";
import useResizeListener from "../../../../hooks/useResizeListener";
import LocationEstablishmentFilter from "../components/LocationEstablishmentFilter";
import useEstablishmentFilterSelection from "../../hooks/useEstablishmentFilterSelection";

export default function OfficeView() {
    const isMobile = useResizeListener(768);
    const { establishments, orderedEstablishments, setEstablishments, setOfficesToEstablishments, setCallersToEstablishments, setTotemList } = useLocationConfigContext();

    const [elimOffice, setElimOffice] = useState<Office>()
    const [openRemoveModal, setOpenRemoveModal] = useState(false);
    const [indexToRemove, setIndexToRemove] = useState<number | null>(null);
    const { selectedEstablishmentIds, setSelectedEstablishmentIds } = useEstablishmentFilterSelection(isMobile);
    const dispatch = useDispatch();

    const updateOffices = (offices: Office[], estIndex: number) => { //Actualiza la lista auxiliar en la real
        const updatedEstablishments = [...establishments];
        updatedEstablishments[estIndex].offices = offices;
        setEstablishments(updatedEstablishments);
        setCallersToEstablishments(updatedEstablishments)   //Para que si están asociados, se actualicen los datos del consultorio en esos lugares
        setTotemList()                                      //-^
    };

    const handleOpenRemoveModal = (office: Office, idxToRemove: number) => {
        setIndexToRemove(idxToRemove)
        setElimOffice(office) //se usa para eliminar en este flujo
        setOpenRemoveModal(true)
    }
    const handleDelete = async (office: Office) => {
        if (office.hospitallocation && office.hospitallocation > 0)
        await removeHospitalLocation(office.hospitallocation)
        .then(async () => {
            const estIndex = establishments.findIndex(e => e.buildingid === office.building);
            if (estIndex >= 0) {
            const updated = establishments[estIndex].offices.filter((_, i) => i !== (indexToRemove ?? -1));
            updateOffices(updated, estIndex);
            }
            await setOfficesToEstablishments();
            setElimOffice(null);
            setIndexToRemove(null);
            setOpenRemoveModal(false);
            dispatch(setNotification({ title: "Eliminación exitosa", desc: 'Se ha eliminado el consultorio', icon: 'pi-check-circle', typeOfNotification: ETypeOfNotification.INFO }));
        }).catch((err) => {
            console.error(err)
            if (err.response?.status === 409) {
                if (err.response?.data === 'ASSOCIATED_CALLER')
                    dispatch(setNotification({ title: "No se puede eliminar", desc: "Debe desasociar del llamador antes de eliminar.", icon: 'pi-exclamation-triangle', typeOfNotification: ETypeOfNotification.WARNING }));
                if (err.response?.data === 'ASSOCIATED_TOTEM')
                    dispatch(setNotification({ title: "No se puede eliminar", desc: "Debe desasociar del tótem antes de eliminar.", icon: 'pi-exclamation-triangle', typeOfNotification: ETypeOfNotification.WARNING }));
            } else
                dispatch(setNotification({ title: "Error", desc: "No se pudo eliminar el consultorio", icon: 'pi-times-circle', typeOfNotification: ETypeOfNotification.ERROR }));
        });
    };

    const establishmentsToRender = isMobile
        ? orderedEstablishments.filter(est => selectedEstablishmentIds.includes(est.buildingid))
        : orderedEstablishments;

    return (
        <div>
            <h1 className="title2">Consultorio</h1>
            <div className="flex flex-row justify-content-between emr-border-bottom pb-2">
                <p className="grey-color">Las salas se asocian a los sectores de establecimientos creados.</p>
            </div>

            {isMobile && (
                <LocationEstablishmentFilter
                    establishments={orderedEstablishments}
                    selectedEstablishmentIds={selectedEstablishmentIds}
                    onChange={setSelectedEstablishmentIds}
                />
            )}


            {establishmentsToRender.map((est) => {
                const realIndex = establishments.findIndex(x => x.buildingid === est.buildingid);
                return (
                <div key={est.buildingid} className="my-5">
                    {!isMobile && <div className="flex flex-row gap-4">
                        <h2 className="title3">{est.buildingname}</h2>
                        <p className="grey-color mt-1">{est.buildingaddress}</p>
                    </div>}
                    <OfficeTable
                        offices={est.offices}
                        onChange={(newOffices) => updateOffices(newOffices, realIndex)}
                        onDelete={(office, idx) => handleOpenRemoveModal(office, idx)}
                        sectors={est.sectors}
                        mobileTitle={est.buildingname}
                        mobileSubtitle={est.buildingaddress}
                    />
                </div>
                );
            })}

            <Modal className="location-mobile-editor-modal" visible={openRemoveModal} setVisible={setOpenRemoveModal} header={"Estás por eliminar el consultorio"} headerStyle={{ fontSize: '12px', textAlign: 'center' }} width='w-medium' closable={false}>
                <div>
                    <p className="grey-color">No podrás eliminar consultorios que estén asociados a un sector.</p>
                    <div style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                        <Button id="deletebutton" label="Si, eliminar" onClick={() => handleDelete(elimOffice)} className="w-full buttonMain" />
                        <Button id="canceldeletebutton" label={"Cancelar"} onClick={() => setOpenRemoveModal(false)} className="w-full btnCancel2" />
                    </div>
                </div>
            </Modal>
        </div>
    )
}


